import {
    get,
    put,
} from '../utility/Requests';

interface IFolderFltConfiguration {
    folderKey: string;
    isFltEnabled: boolean;
}

// Proxied through the portal BE, which forwards to License Accountant (see routes/Licensing/FolderConfiguration).
// The organization is resolved from the authenticated token on the BE, so it is not part of the path.
const folderConfigurationUri = '/api/folder-configurations';

const fltConfigurationPath = (tenantId: string, folderKey: string) =>
    `${folderConfigurationUri}/${tenantId}/flt/${folderKey}`;

export function getFolderFltConfiguration(tenantId: string, folderKey: string) {
    return get<IFolderFltConfiguration>(fltConfigurationPath(tenantId, folderKey));
}

export function setFolderFltConfiguration(tenantId: string, folderKey: string, isFltEnabled: boolean) {
    return put<IFolderFltConfiguration>(fltConfigurationPath(tenantId, folderKey), { body: { isFltEnabled } });
}
